








import Vue from 'vue'
import BaseLayout from '@/layout/BaseLayout.vue'
import Integration from '@/components/Integration/Integration.vue'

export default Vue.extend<{}, {}, {}, {}>({
  components: {
    Integration,
    BaseLayout,
  },
  metaInfo() {
    return { title: this.$tc('settings.integration', 1) }
  },
})
